import React from "react"

function IconArrowsFitWidth({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="arrows-fit-width"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-arrows-fit-width"
      {...props}
    >
      <path
        d="m8.088 15.295-4.38-3.286v5.182a.655.655 0 0 1-1.3.107l-.009-.107V6.796a.655.655 0 0 1 1.3-.106l.01.106-.002 5.05 4.38-3.285v2.777h7.856V8.561l4.36 3.27V6.795a.655.655 0 0 1 1.3-.106l.01.106V17.19a.655.655 0 0 1-1.301.107l-.009-.107v-5.167l-.77.578v.046h-.06l-3.53 2.647v-2.648H8.087v2.648z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconArrowsFitWidth
